<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total" @Export="customerExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Secondarydealerfilestable from "./components/secondarydealerfilestable.vue";

	import {
		GetBOSSCustomerList,
		ExportBOSSCustomerData
	} from "@/api/newsapi";
	import {
		InventoryClassList
	} from "@/api/home";

	import utils from "../../../common/utils";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable,
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				form: {},
				productLineOptions: [],
				formdata: [{
						inputdata: "",
						title: "关系标识",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择产品线",
						inputtype: "select",
						width: "220px",
						lablewith: "117px",
						options: []
					},
					{
						inputdata: "",
						title: "公司负责人",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					}
				],
			};
		},
		mounted() {
			this.customerList();
			this.initProductLineOptions();
		},
		methods: {
			// 初始化产品线选项
			initProductLineOptions() {
				InventoryClassList().then(res => {
					if (res.code === 0) {
						this.formdata[1].options = res.data.data.map(item => ({
							key: item.InvClass,
							value: item.InvClassName
						}));
					}
				}).catch(err => {
					console.error('获取产品线列表失败:', err);
				});
			},
			// 列表
			async customerList() {
				let {
					data,
					code
				} = await GetBOSSCustomerList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
				});
			},
			select() {
				this.pageindex = 1;
				this.form.BOSSCode = this.$refs.seselect[0].modelvalue;
				this.form.InvClass = this.$refs.seselect[1].modelvalue;
				this.form.BOSSName = this.$refs.seselect[2].modelvalue;
				this.form.Customer = this.$refs.seselect[3].modelvalue;
				this.customerList();
			},
			// 导出
			async customerExport() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportBOSSCustomerData({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "定义关联公司报表", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 120px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>